import { render, staticRenderFns } from "./ClientPortfolioTable.vue?vue&type=template&id=d73b1c8c"
import script from "./ClientPortfolioTable.vue?vue&type=script&lang=js"
export * from "./ClientPortfolioTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports